"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parserIdentifierExpression = void 0;
const typeParser_1 = require("../typeParser");
const parserIdentifierExpression = (BaseClass) => {
    const DerivedClass = class extends BaseClass {
        visitVariableDeclarationExpression(ctx) {
            const idWithType = this.visitIdentifierWithType(ctx.identifierWithType());
            return {
                identifier: { type: 'Identifier', name: idWithType.name, isPointer: false },
                identifierType: idWithType.typeDeclaration,
                type: 'VariableDeclarationExpression'
            };
        }
        visitIdentifierWithType(ctx) {
            const type = new typeParser_1.TypeParser().visit(ctx._idType);
            return {
                type: 'TypedIdentifier',
                name: ctx.IDENTIFIER().text,
                typeDeclaration: type
            };
        }
        visitIdentifierExpression(ctx) {
            return {
                type: 'Identifier',
                name: ctx.IDENTIFIER().text,
                isPointer: false
            };
        }
    };
    return DerivedClass;
};
exports.parserIdentifierExpression = parserIdentifierExpression;
//# sourceMappingURL=identifierParser.js.map